import '@tensorflow/tfjs-backend-webgl';
import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm';
import {PoseEstimation} from './PoseEstimation'
import {HandEstimation} from './HandEstimation'
import {TensorFlowEnv} from './TensorFlowEnv'
import {WecCam} from './WecCam'
import {CameraRenderer} from './CameraRenderer'
import * as posedetection from "@tensorflow-models/pose-detection";
import {VideoCapture} from "../VideoCapture";
tfjsWasm.setWasmPaths(`https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`);

export class GameManager {
  constructor(game, options) {
    this.state = 'init'
    this.game = game
    this.shouldPoseEstimate = true
    this.poseEstimate = new PoseEstimation(this.game.poseMode, options)
    if (this.game.handMode) {
      this.handEstimate = new HandEstimation(this.game.poseMode, options)
    }
    this.camera = new WecCam()
    this.cameraRenderer = new CameraRenderer()
    this.game.cameraRenderer = this.cameraRenderer
    this.videoCapture = new VideoCapture()
  }

  startCapture() {
    this.game.stopRecordCallback = () => this.stopCapture()
    this.videoCapture.startRecord()
  }

  stopCapture() {
    this.videoCapture.stopRecord()
  }

  async setUp() {
    // this.game.initPhysics(this.cameraRenderer.width, this.cameraRenderer.height)
    await TensorFlowEnv.setEnv()
    if (this.shouldPoseEstimate) {
      await this.poseEstimate.createDetector()
    }
    if (this.handEstimate) {
      await this.handEstimate.createDetector()
    }
    await this.camera.setupCamera({targetFPS: 60, sizeOption: 'full'})
    await this.cameraRenderer.setup(this.poseEstimate.model)

    this.game.setRect(this.cameraRenderer.width, this.cameraRenderer.height)
    if (window.location.search.indexOf('debug') !== -1) {
      this.game.debugMode = true
      this.cameraRenderer.debugMode = true
    }

    await this.camera.waitUntilReady()
    this.cameraRenderer.setCanvasPos()
    this.game.initPhysics(this.cameraRenderer.width, this.cameraRenderer.height, this.cameraRenderer.offsetX, this.cameraRenderer.offsetY)

    this.state = 'ready'
  }

  async mainLoop() {
    await this.camera.waitUntilReady()
    const pose = this.shouldPoseEstimate ? await this.poseEstimate.estimatePoses(this.camera.video) : []
    const hands = this.handEstimate ? await this.handEstimate.estimatePoses(this.camera.video) : []
    this.cameraRenderer.draw(this.camera.video, pose, hands);
    this.game.mainLoop({ pose, hands })
    this.game.renderCamera(this.cameraRenderer.ctx, { pose, hands })
  }
}



// WEBPACK FOOTER //
// ./src/components/common/GameManager.js